<template>
  <div class="payment-icons">
    <img
      :src="src"
      alt="payment-icon"
      class="payment-icons__icon"
    />
  </div>
</template>

<script>
import IconCard from '@images/card-icon.png';
import IconCardMethods from '@images/payment-systems.png';
import IconCardMethodsDisabled from '@images/payment-systems-disabled.png';
import IconWallet from '@images/wallet-icon.png';
import IconCash from '@images/cash-icon.png';
import IconSber from '@images/sber.png';
import IconSamsung from '@images/samsung.png';
import IconGPay from '@images/google.png';
import IconFPS from '@images/spb.png';

export default {
  name: 'payment-systems',

  icons: {
    IconCard,
    IconCardMethods,
    IconCardMethodsDisabled,
    IconCash,
    IconWallet,
    IconSber,
    IconSamsung,
    IconGPay,
    IconFPS,
  },

  props: {
    icon: {
      type: String,
      required: true
    }
  },

  computed: {
    src() {
      return this.$options?.icons[this.icon] || '';
    }
  }
}
</script>

<style lang="scss">
.payment-icons {
  display: flex;
  align-items: center;

  &__icon {
    max-height: 24px;
    width: auto;
    object-fit: cover;
  }
}
</style>
